export default {"src":"/_next/static/image/public/images/flags/flag_1_us.7dd49dbf2274fd5ccb83fe33a407c75e.svg","height":16,"width":24};